import { useState } from "react"

export const useForm = (init = {}) => {
    const [internalState, setInternalState] = useState(init)
    const OnChange = ({target}) => { 
        setInternalState((state)=>{
            return { ...state, [target.name]:target.value }
        })        
    }    
    return {
        inputValues:internalState,
        setInputValues:setInternalState,
        OnChange
    }
}


